var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2962 4.2275L14.0413 9.856H19.6848C19.989 9.856 20.1171 10.2689 19.8689 10.4542L15.3061 13.9341L17.0512 19.5626C17.1472 19.866 16.811 20.1272 16.5628 19.9334L12 16.4535L7.43715 19.9334C7.189 20.1188 6.85279 19.866 6.94885 19.5626L8.69394 13.9341L4.13109 10.4542C3.88293 10.2689 4.01101 9.856 4.3152 9.856H9.95873L11.7038 4.2275C11.7999 3.92417 12.2001 3.92417 12.2962 4.2275Z",
    fill: "#F0002E",
    stroke: "#F0002E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/fillStar.b9d4ce66782481a90aa1e3f5c793b87a.svg";
export { ForwardRef as ReactComponent };